<template>
    <div class="rating-container">
        <div class="rating-title">
            <h4>{{ title }}</h4>
        </div>
        <div class="rating-info">
            <strong class="rating-score" :style="{ color: _scoreColor }">{{ score }}</strong>
            <div class="rating-right">
                <div class="rating-count">
                    <span>{{ ratingCount }}</span>人评价
                </div>
            </div>
        </div>
        <div class="rating-bars">
            <div v-for="i in [ 4, 3, 2, 1, 0 ]" :key="i" class="rating-bar">
                <span class="fl">{{ labels[i] }}</span>
                <div class="bar" :style="{ width: calBarWidth(i) }"></div>
                <span class="fl">{{ ratingStat[i] }}</span>
            </div>
        </div>
    </div>
</template>

<script>
import { default as ARate } from 'ant-design-vue/es/rate';

export default {
    props: {
        title: String,
        scoreColor: [ String, Function ],
        rating: Array,
        labels: Array,
        formula: Function,
    },
    computed: {
        ratingStat() {
            return this.rating.slice(1);
        },
        ratingCount() {
            return this.ratingStat.reduce((sum, e) => sum + e, 0);
        },
        score() {
            return this.formula(this.ratingStat);
        },
        _scoreColor() {
            if (typeof this.scoreColor === 'string') {
                return this.scoreColor;
            }
            return this.scoreColor(this.score);
        },
    },
    methods: {
        calBarWidth(index) {
            const max = Math.max(...this.ratingStat);
            return 80 * this.ratingStat[index] / max + "px";
        }
    },
    components: {
        ARate,
    }
}
</script>

<style lang="less" scoped>
.rating-container {
    color: #9b9b9b;
    padding-bottom: 15px;
    font-size: 13px;
    line-height: 16px;
    width: 180px;
    text-align: left;
}
.rating-title {
    font-size: 15px;
    color: #555555;
    h4 {
        margin: 0;
    }
}
.rating-info {
    padding: 0;
    line-height: 2;
    display: flex;
    align-items: baseline;
}
.rating-right {
    padding: 30px 0 10px 10px;
}
.rating-score {
    padding: 0;
    min-width: 30%;
    font-size: 32px;
}
.rating-bar {
    display: flex;
    .bar {
        background-color: #ffd596;
        margin: 1px 5px 0;
        height: 13px;
        transition: width 0.5s;
    }
}
</style>